module.exports = "//static.hsappstatic.net/ui-addon-upgrades/static-9.18149/js/img/valuePropModals/SequencesEmailCommunicator/ValueProp1.svg"